<nav class="usa-breadcrumb" aria-label="Breadcrumbs,,">
  <ol class="usa-breadcrumb__list">
    <li class="usa-breadcrumb__list-item" *ngFor="let breadcrumb of breadCrumbs$ | async">
      <a *ngIf= "breadcrumb.isActive === true" class="usa-breadcrumb__link">
        <span>{{breadcrumb.title}}</span></a>
      <a *ngIf= "breadcrumb.isActive === false" [routerLink]="['/' + breadcrumb.url]" [queryParams]="breadcrumb.params" class="usa-breadcrumb__link">
        <span>{{breadcrumb.title}}</span>
      </a>
    </li>
    <!--<li class="usa-breadcrumb__list-item usa-current" aria-current="page">
      <span>Women-owned small business federal contracting program</span>
    </li>-->
  </ol>
</nav>
